<script setup>
import { useAuthStore } from '~/stores/auth'
import { useBasketStore } from '~/stores/basket'

const basketStore = useBasketStore()
const authStore = useAuthStore()
</script>

<template>
  <div>
    <NuxtLoadingIndicator
      color="#fff"
      :throttle="500"
    />
    <Teleport to="body">
      <ContactEmail
        id="summary-email"
        :items="[authStore?.settings?.help_email]"
      />
      <ContactPhone
        id="summary-phone"
        :items="[authStore?.settings?.help_phone]"
      />
    </Teleport>
    <div class="container container--main">
      <PageNavigation />
      <slot />
      <DelayHydration>
        <LazyPageFooter />
      </DelayHydration>
    </div>
    <ClientOnly>
      <DelayHydration>
        <LazyGlobalAlert />
        <LazySearchMask />
        <LazyModalShoppingCart />
        <LazyProductShoppingCart
          id="common"
          :message="true"
          :quantity="basketStore.cartModalVal('common', 'quantity')"
          :price-info="basketStore.cartModalVal('common', 'price')"
          :payment="true"
        />
      </DelayHydration>
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped></style>
